/**
 * Les Parisiennes — Header Module
 */
(function () {
  'use strict';
  var LP = window.LPTheme || {};

  var safeStorageGet = LP.safeStorageGet || function (key) { try { return window.localStorage ? localStorage.getItem(key) : null; } catch (e) { return null; } };
  var safeStorageSet = LP.safeStorageSet || function (key, value) { try { if (window.localStorage) localStorage.setItem(key, value); } catch (e) {} };
  var activateFocusTrap = LP.activateFocusTrap || function () {};
  var deactivateFocusTrap = LP.deactivateFocusTrap || function () {};

  function registerInit(name, fn) {
    if (LP && typeof LP.registerInit === 'function') LP.registerInit(name, fn);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ============================================================
   * 2. STICKY HEADER
   * ============================================================ */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    /* Theme Editor section reloads: tear down listeners from a previous
       run before re-binding so window.scroll doesn't accumulate handlers
       referencing dead DOM. */
    if (window.__lpStickyAbort && typeof window.__lpStickyAbort.abort === 'function') {
      try { window.__lpStickyAbort.abort(); } catch (e) { /* ignore */ }
    }
    var hasAbort = typeof window.AbortController === 'function';
    var ctrl = hasAbort ? new AbortController() : null;
    window.__lpStickyAbort = ctrl;
    var listenerOpts = ctrl ? { passive: true, signal: ctrl.signal } : { passive: true };
    checkAnnouncementState();
    var announcement = document.querySelector('.announcement-bar');
    var root = document.documentElement;
    var announcementH = 0;
    var headerH = 0;
    var lastY = Math.max(0, window.pageYOffset);
    var ticking = false;

    function refreshHeaderMetrics() {
      announcementH = announcement ? announcement.offsetHeight : 0;
      headerH = header.offsetHeight;
      /* Write to measured-only variables so they cannot feed back into
         .site-header__inner { height: ... } and trigger Safari layout loops. */
      root.style.setProperty('--announcement-measured-height', announcementH + 'px');
      root.style.setProperty('--header-measured-height', headerH + 'px');
      root.style.setProperty('--header-total-measured-height', (announcementH + headerH) + 'px');
    }

    function updateHeader(y) {
      /* Safari rubber-band scrolling can report a negative offset. */
      y = Math.max(0, y);
      var delta = y - lastY;
      var slide = Math.min(y, announcementH);
      var hideOnScroll = header.getAttribute('data-hide-on-scroll') !== 'false';

      if (announcement) {
        announcement.style.transform = 'translate3d(0,-' + slide + 'px,0)';
      }
      header.style.top = (announcementH - slide) + 'px';

      header.classList.toggle('site-header--scrolled', y > announcementH);

      if (hideOnScroll && delta > 5 && y > headerH + announcementH) {
        header.classList.add('site-header--hidden');
      }
      if (!hideOnScroll || delta < -4 || y <= 10) {
        header.classList.remove('site-header--hidden');
      }

      lastY = y;
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateHeader(window.pageYOffset);
      });
    }

    if (window.__lpHeaderResizeObserver) window.__lpHeaderResizeObserver.disconnect();
    if (typeof window.ResizeObserver === 'function') {
      window.__lpHeaderResizeObserver = new ResizeObserver(function () {
        refreshHeaderMetrics();
        requestUpdate();
      });
      window.__lpHeaderResizeObserver.observe(header);
      if (announcement) window.__lpHeaderResizeObserver.observe(announcement);
    }
    refreshHeaderMetrics();
    updateHeader(lastY);

    window.addEventListener('scroll', requestUpdate, listenerOpts);
    window.addEventListener('resize', function () {
      refreshHeaderMetrics();
      requestUpdate();
    }, listenerOpts);
  }

  /* ============================================================
   * 3. MOBILE NAV
   * ============================================================ */
  /* ── Mobile accordion: one group open at a time ── */
  function setMobileGroupState(group, open) {
    group.classList.toggle('is-open', open);
    var button = group.querySelector('.mobile-nav__link--parent');
    var sub = group.querySelector('.mobile-nav__sub-links');
    if (button) button.setAttribute('aria-expanded', String(open));
    if (sub) {
      sub.setAttribute('aria-hidden', String(!open));
      sub.inert = !open;
    }
  }

  window.toggleMobileGroup = function (group) {
    var open = !group.classList.contains('is-open');
    var nav = group.closest('.mobile-nav');
    if (nav && open) {
      nav.querySelectorAll('.mobile-nav__group.is-open').forEach(function (other) {
        if (other !== group && !other.contains(group) && !group.contains(other)) {
          setMobileGroupState(other, false);
        }
      });
    }
    /* CSS animates the natural height, with no delayed callback to race a tap. */
    setMobileGroupState(group, open);
  };

  window.toggleMobileNav = function () {
    var drawer = document.getElementById('mobile-nav');
    var overlay = document.getElementById('mobile-nav-overlay');
    var toggle = document.getElementById('menu-toggle');
    if (!drawer) return;
    var isOpen = drawer.classList.contains('is-open');
    if (!isOpen) {
      var scrollArea = drawer.querySelector('.mobile-nav__scroll');
      if (scrollArea) scrollArea.scrollTop = 0;
    }
    drawer.classList.toggle('is-open');
    if (overlay) overlay.classList.toggle('is-open');
    if (toggle) {
      toggle.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
    document.body.style.overflow = isOpen ? '' : 'hidden';
    drawer.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    drawer.inert = isOpen;
    if (isOpen) {
      var searchInput = drawer.querySelector('[data-predictive-search-input]');
      if (searchInput && searchInput.__lpPredictiveCancel) searchInput.__lpPredictiveCancel();
      deactivateFocusTrap(drawer);
    }
    else activateFocusTrap(drawer);
  };

  /* ============================================================
   * 4b. LOCALE / CURRENCY MODAL
   * ============================================================ */
  window.toggleLocaleDrawer = function () {
    var modal = document.getElementById('locale-drawer');
    var overlay = document.getElementById('locale-overlay');
    if (!modal) return;
    var isOpen = modal.classList.contains('is-open');
    if (!isOpen) {
      modal.hidden = false;
      if (overlay) overlay.hidden = false;
    }
    modal.classList.toggle('is-open');
    if (overlay) overlay.classList.toggle('is-open');
    document.body.style.overflow = isOpen ? '' : 'hidden';
    modal.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    if (isOpen) {
      deactivateFocusTrap(modal);
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
        if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
      }, 400);
    } else {
      activateFocusTrap(modal);
    }
  };

	  window.applyLocaleSettings = function () {
	    /* Single form now handles both country and locale */
	    var form = document.getElementById('modal-localization-form');
	    if (form) {
	      form.submit();
	    }
	  };

  function syncLocalizationLanguageOptions(form) {
    var countrySelect = form.querySelector('[data-country-select]');
    var languageSelect = form.querySelector('[data-language-select]');
    if (!countrySelect || !languageSelect) return;

    var selected = countrySelect.options[countrySelect.selectedIndex];
    var allowed = selected ? String(selected.dataset.languages || '').split(',').filter(Boolean) : [];
    var currentIsAllowed = false;

    Array.prototype.slice.call(languageSelect.options).forEach(function (option) {
      var isAllowed = !allowed.length || allowed.indexOf(option.value) !== -1;
      option.disabled = !isAllowed;
      option.hidden = !isAllowed;
      if (isAllowed && option.selected) currentIsAllowed = true;
    });

    if (!currentIsAllowed) {
      var firstAllowed = Array.prototype.slice.call(languageSelect.options).find(function (option) {
        return !option.disabled;
      });
      if (firstAllowed) firstAllowed.selected = true;
    }
  }

  function initLocalizationForms() {
    document.querySelectorAll('.localization-form').forEach(function (form) {
      if (form.__lpLocalizationBound) return;
      form.__lpLocalizationBound = true;
      syncLocalizationLanguageOptions(form);
      var countrySelect = form.querySelector('[data-country-select]');
      if (countrySelect) {
        countrySelect.__lpInitialCountry = countrySelect.value;
        countrySelect.addEventListener('change', function () {
          syncLocalizationLanguageOptions(form);
        });
      }
      form.addEventListener('submit', function () {
        var returnTo = form.querySelector('[data-localization-return-to]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
        if (countrySelect && countrySelect.value && countrySelect.value !== countrySelect.__lpInitialCountry) {
          safeStorageSet('lp-country-manual-selection', '1');
        }
      });
    });
  }

	  function initHeaderControls() {
	    /* Per-element guard so Theme Editor section reloads don't double-bind clicks. */
	    function bindOnce(selector, handler) {
	      document.querySelectorAll(selector).forEach(function (control) {
	        if (control.__lpBoundHeader) return;
	        control.__lpBoundHeader = true;
	        control.addEventListener('click', function (e) {
	          e.preventDefault();
	          handler();
	        });
      });
	    }
	    bindOnce('[data-mobile-nav-toggle]', function () { window.toggleMobileNav(); });
	    bindOnce('[data-theme-toggle]',      function () { window.toggleTheme(); });
	    bindOnce('[data-locale-toggle]',     function () { window.toggleLocaleDrawer(); });
	    bindOnce('[data-search-toggle]',     function () { window.toggleSearch(); });
	    bindOnce('[data-cart-toggle]',       function () { window.toggleCartDrawer(); });
	    initLocalizationForms();
	  }
  /* ============================================================
   * 16. ANNOUNCEMENT BAR
   * ============================================================ */
  window.closeAnnouncement = function () {
    var bar = document.querySelector('.announcement-bar');
    if (bar) {
      bar.style.maxHeight = bar.offsetHeight + 'px';
      requestAnimationFrame(function () {
        bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        bar.style.maxHeight = '0'; bar.style.opacity = '0'; bar.style.overflow = 'hidden';
      });
      try { if (window.sessionStorage) sessionStorage.setItem('announcement-closed', '1'); } catch (e) {}
    }
  };

  function checkAnnouncementState() {
    var closed = false;
    try { closed = window.sessionStorage && sessionStorage.getItem('announcement-closed') === '1'; } catch (e) {}
    if (closed) {
      var bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }
  /* ============================================================
   * 20. HEADER DROPDOWN MENUS
   * ============================================================ */
  function initHeaderDropdowns() {
    document.querySelectorAll('.nav-item--has-children').forEach(function (item) {
      if (item.__lpDropdownBound) return;
      item.__lpDropdownBound = true;
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        document.querySelectorAll('.nav-item--has-children.is-open').forEach(function (o) { if (o !== item) o.classList.remove('is-open'); });
        item.classList.add('is-open');
      });
      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { item.classList.remove('is-open'); }, 200);
      });
    });
  }

  /* ============================================================
   * 21. DARK THEME TOGGLE
   * ============================================================ */
	  window.toggleTheme = function () {
    var html = document.documentElement;
    var current = html.getAttribute('data-theme');
    var next = current === 'dark' ? 'light' : 'dark';
    html.setAttribute('data-theme', next);
    safeStorageSet('les-parisiennes-theme', next);
  };

  function initTheme() {
    var saved = safeStorageGet('les-parisiennes-theme');
    document.documentElement.setAttribute('data-theme', saved === 'light' ? 'light' : 'dark');
  }
  function initResponsiveRecalc() {
    /* Theme Editor reloads: abort previous controller so listeners drop. */
    if (window.__lpRecalcAbort && typeof window.__lpRecalcAbort.abort === 'function') {
      try { window.__lpRecalcAbort.abort(); } catch (e) { /* ignore */ }
    }
    var hasAbort = typeof window.AbortController === 'function';
    var ctrl = hasAbort ? new AbortController() : null;
    window.__lpRecalcAbort = ctrl;
    var listenerOpts = ctrl ? { passive: true, signal: ctrl.signal } : { passive: true };
    var frame = null;
    function recalc() {
      frame = null;
      var header = document.getElementById('site-header');
      var announcement = document.querySelector('.announcement-bar');
      /* Measured vars only — never write the configured --header-height
         because .site-header__inner uses it to set its own height. */
      if (header) document.documentElement.style.setProperty('--header-measured-height', header.offsetHeight + 'px');
      if (announcement) document.documentElement.style.setProperty('--announcement-measured-height', announcement.offsetHeight + 'px');
      var activeSlide = document.querySelector('.gallery-main__slide.is-active');
      if (activeSlide && typeof window.galleryGoTo === 'function') {
        window.galleryGoTo(parseInt(activeSlide.dataset.index || '0', 10));
      }
    }
    function queueRecalc() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(recalc);
    }
    queueRecalc();
    window.addEventListener('resize', queueRecalc, listenerOpts);
    window.addEventListener('orientationchange', queueRecalc, listenerOpts);
  }

  /* Refresh only after account navigation, so a restored Safari page uses
     Shopify's current customer session rather than its cached guest markup. */
  document.addEventListener('click', function (event) {
    var login = event.target.closest && event.target.closest('[data-account-login]');
    if (!login || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try { sessionStorage.setItem('lp-account-navigation', '1'); } catch (e) {}
  });
  window.addEventListener('pageshow', function (event) {
    var pending = false;
    try {
      pending = sessionStorage.getItem('lp-account-navigation') === '1';
      sessionStorage.removeItem('lp-account-navigation');
    } catch (e) {}
    if (event.persisted && pending) window.location.reload();
  });

  registerInit('initStickyHeader', initStickyHeader);
  registerInit('checkAnnouncementState', checkAnnouncementState);
  registerInit('initHeaderControls', initHeaderControls);
  registerInit('initHeaderDropdowns', initHeaderDropdowns);
  registerInit('initTheme', initTheme);
  registerInit('initResponsiveRecalc', initResponsiveRecalc);
}());
